// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__13Ao7","content":"LayoutSettings_content__338XE"};